module.exports = __webpack_public_path__ + "img/services-details-2.00cd4ef1.jpg";